import React, { useState } from "react";
import { ImSpinner6 } from "react-icons/im";
import { useTrackContext } from "../../hooks/useTrackContext";

const NewsletterPopup: React.FC = () => {
  const { dispatch, isNewsletterSubscripted } = useTrackContext();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isEmailValid, setIsEmailValid] = useState<boolean>(false);
  const [showError, setShowError] = useState<boolean>(false);
  const [showSpin, setShowSpin] = useState<boolean>();
  const [email, setEmail] = useState<string>("");

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputEmail = event.target.value;
    const isValidEmail = /^[a-zA-Z0-9._]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(inputEmail);
    setEmail(inputEmail);
    setIsEmailValid(isValidEmail);
    setShowError(false);
  };

  const subscribeToNewsletter = async () => {
    if (!isEmailValid) {
      setShowError(true);
      return;
    }
    setShowSpin(true);

    try {
      const response = await fetch(`https://hyperkarting.sfmcshopify.com/api/shopify/subscribe?email=${email}&coupon=WELCOME_10`, {
        method: "POST",
      });

      if (response.ok) {
        // const data = await response.json();

        // console.log("Subscription successful:", data);

        dispatch({
          type: "SET_NEWSLETTER_SUBSCRIPTION",
          payload: {
            isNewsletterSubscripted: true,
          },
        });
      } else {
        console.error("Failed to subscribe:", response.statusText);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    } finally {
      setShowSpin(false);
    }
  };

  return (
    <>
      {isModalOpen && (
        <div className="tw-fixed tw-z-50 tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-gray-900 tw-bg-opacity-50 tw-px-[10px] lg:tw-px-0">
          <div className="tw-bg-[#393B41] lg:tw-max-w-[998px] tw-w-full tw-mx-auto tw-rounded-[16px] tw-shadow-lg tw-overflow-hidden tw-transform tw-transition-all tw-duration-300 tw-scale-100">
            <div className="tw-pb-[46px] lg:tw-pb-[98px]">
              <div className="tw-flex tw-justify-end tw-p-[19px]">
                <button className="tw-text-gray-600 tw-text-lg tw-p-2 tw-hover:text-gray-800 tw-focus:tw-outline-none" onClick={toggleModal}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M19.1183 1.05664L1.48218 18.6928" stroke="#C2C0C3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M19.124 18.7039L1.47314 1.04932" stroke="#C2C0C3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>
              </div>
              {isNewsletterSubscripted ? (
                <>
                  <div className="tw-text-white tw-text-[36px] tw-font-[700] tw-text-center">Thank you for subscribing!</div>
                  <p className="tw-text-white tw-text-[24px] lg:tw-text-[30px] tw-font-[500] tw-text-center tw-mt-12px tw-px-[19px] lg:tw-px-[150px]">
                    Please check your inbox for your 10% off code!
                  </p>
                </>
              ) : (
                <>
                  <div className="tw-text-white tw-text-[36px] tw-font-[700] tw-text-center">Subscribe to Our Newsletter</div>
                  <p className="tw-text-white tw-text-[24px] lg:tw-text-[30px] tw-font-[500] tw-text-center tw-mt-12px tw-px-[19px] lg:tw-px-0">Get 10% off your next purchase</p>
                  <div className="tw-flex tw-flex-col lg:tw-flex-row tw-justify-center tw-items-center tw-gap-[16px] tw-mt-[60px] tw-px-[19px] md:tw-px-[140px] lg:tw-px-0">
                    <input
                      type="email"
                      required
                      value={email}
                      onChange={handleEmailChange}
                      className={`tw-py-[16px] tw-px-[24px] tw-bg-white tw-rounded-full focus:tw-outline-none tw-w-full lg:tw-w-[300px] tw-text-[16px] tw-border-[2px]  tw-font-[400]
                        ${isEmailValid ? "tw-border-green-500" : ""}
                        `}
                      placeholder="Email Address"
                    />
                    <button
                      onClick={subscribeToNewsletter}
                      className={` tw-py-[16px] tw-px-[40px] tw-rounded-full tw-w-full md:tw-w-fit lg:tw-w-auto tw-text-[16px] tw-font-extrabold tw-bg-[linear-gradient(290deg,#F908FF_0%,#D32EFE_8.19%,#37CCFB_87.88%,#05FFFA_100%)] tw-text-white`}
                    >
                      {showSpin ? (
                        <ImSpinner6 className="tw-flex tw-justify-center tw-mx-auto tw-h-[30px] tw-w-[30px] tw-animate-spin tw-transition tw-duration-300 tw-ease-in-out" />
                      ) : (
                        "Get 10% Off"
                      )}
                    </button>
                  </div>
                  {showError && (
                    <>
                      <div className={`tw-bg-[#2F1160] tw-w-fit tw-mx-auto tw-py-[8px] tw-px-[16px] tw-rounded-[8px] tw-mb-[15px] tw-mt-[30px]`}>
                        <span className={`tw-text-[red] tw-font-[700] tw-text-center tw-flex`}>Please enter a valid email address</span>
                      </div>
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NewsletterPopup;
